





































































import Vue, { PropType } from 'vue';
import { Item, ItemData } from 'mostra';

export const imageLengthArray = {
  1: 3,
  2: 3,
  3: 5,
  6: 2,
  7: 1,
  101: 3,
  102: 2,
  103: 1,
};

interface DataType {
  selectedItems: ItemData[];
  maxLength: number;
}

export default Vue.extend({
  name: 'GLineupItemGroup',
  props: {
    owner: { type: String as PropType<string>, required: true },
    lineupIndex: { type: Number as PropType<number>, default: 0 },
    value: { type: Number as PropType<number>, default: null },
    items: { type: Array as PropType<Item[]>, default: () => [] },
    onSelectItem: { type: Function as PropType<() => void> },
    selectedItemIds: { type: Array as PropType<string[]> },
    onDelete: { type: Function as PropType<(index: number, lienupIndex: number) => () => void> },
    onSwap: {
      type: Function as PropType<(mode: string, index: number, lineupIndex: number) => () => void>,
    },
  },
  data(): DataType {
    return {
      selectedItems: [],
      maxLength: imageLengthArray[Number(this.value)],
    };
  },
  methods: {
    setSelectedItems() {
      const selectedItems = this.selectedItemIds.reduce((result: ItemData[], itemId: string) => {
        const item = this.items.find((val: Item) => itemId === val.id);
        if (item) result.push(item.data);
        return result;
      }, []);
      this.selectedItems = selectedItems;
    },
  },
  watch: {
    selectedItemIds() {
      this.setSelectedItems();
    },
  },
  mounted() {
    this.setSelectedItems();
  },
});
